(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9541],{

/***/ 82324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ bookpage_BookPageHome; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(57135);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9970);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(15767);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/image.js
var next_image = __webpack_require__(26538);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/bookpage/bookpagehome.module.scss
var bookpagehome_module = __webpack_require__(2802);
var bookpagehome_module_default = /*#__PURE__*/__webpack_require__.n(bookpagehome_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-awesome-reveal@4.3.1_@emotion+react@11.14.0_@types+react@18.0.21_react@18.2.0_sup_9ec67bc2838b979fc11a3db5ae856235/node_modules/react-awesome-reveal/dist/index.js + 2 modules
var dist = __webpack_require__(56399);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-scroll@1.9.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(99585);
// EXTERNAL MODULE: ./node_modules/.pnpm/axios@1.18.1_debug@4.4.3_supports-color@7.2.0__supports-color@7.2.0/node_modules/axios/lib/axios.js + 50 modules
var axios = __webpack_require__(81944);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(57389);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
// EXTERNAL MODULE: ./components/bookpage/addcart.module.scss
var addcart_module = __webpack_require__(3721);
var addcart_module_default = /*#__PURE__*/__webpack_require__.n(addcart_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hot-toast@2.6.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-hot-toast/dist/index.mjs + 1 modules
var react_hot_toast_dist = __webpack_require__(57337);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/router.js
var next_router = __webpack_require__(96376);
// EXTERNAL MODULE: ./components/Button/index.ts + 1 modules
var Button = __webpack_require__(32033);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./components/Radio/Radio.module.scss
var Radio_module = __webpack_require__(89482);
var Radio_module_default = /*#__PURE__*/__webpack_require__.n(Radio_module);
;// CONCATENATED MODULE: ./components/Radio/Radio.tsx






var Radio = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var label = _param.label, checked = _param.checked, _defaultChecked = _param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? false : _defaultChecked, onChange = _param.onChange, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _size = _param.size, size = _size === void 0 ? "md" : _size, _color = _param.color, color = _color === void 0 ? "primary" : _color, _className = _param.className, className = _className === void 0 ? "" : _className, _labelClassName = _param.labelClassName, labelClassName = _labelClassName === void 0 ? "" : _labelClassName, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "checked",
        "defaultChecked",
        "onChange",
        "disabled",
        "size",
        "color",
        "className",
        "labelClassName",
        "error"
    ]);
    var _$ref = (0,react.useState)(defaultChecked), isChecked = _$ref[0], setIsChecked = _$ref[1];
    var _$ref1 = (0,react.useState)(false), isFocused = _$ref1[0], setIsFocused = _$ref1[1];
    var currentChecked = checked !== undefined ? checked : isChecked;
    var handleChange = function(e) {
        var newChecked = e.target.checked;
        if (checked === undefined) {
            setIsChecked(newChecked);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(newChecked);
    };
    var handleFocus = function() {
        setIsFocused(true);
    };
    var handleBlur = function() {
        setIsFocused(false);
    };
    var radioClasses = [
        (Radio_module_default()).radio,
        (Radio_module_default())["size-".concat(size)],
        (Radio_module_default())["color-".concat(color)],
        currentChecked && (Radio_module_default()).checked,
        disabled && (Radio_module_default()).disabled,
        isFocused && (Radio_module_default()).focused,
        error && (Radio_module_default()).error,
        className, 
    ].filter(Boolean).join(" ");
    var labelClasses = [
        (Radio_module_default()).label,
        disabled && (Radio_module_default()).labelDisabled,
        error && (Radio_module_default()).labelError,
        labelClassName, 
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Radio_module_default()).radioContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: radioClasses,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        ref: ref,
                        type: "radio",
                        checked: currentChecked,
                        onChange: handleChange,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        disabled: disabled,
                        className: (Radio_module_default()).input,
                        id: "radio-".concat(Math.random().toString(36).substr(2, 9))
                    }, props)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Radio_module_default()).radioCircle,
                        style: error ? {
                            borderColor: "var(--color-error)"
                        } : {},
                        children: currentChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Radio_module_default()).radioDot
                        })
                    })
                ]
            }),
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: props.id || "radio-".concat(Math.random().toString(36).substr(2, 9)),
                className: labelClasses,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                    variant: "text-sm",
                    as: "span",
                    color: disabled ? "disabled" : error ? "error" : "secondary",
                    weight: "normal",
                    children: label
                })
            })
        ]
    });
});
Radio.displayName = "Radio";
/* harmony default export */ var Radio_Radio = (Radio);

;// CONCATENATED MODULE: ./components/Radio/index.ts


// EXTERNAL MODULE: ./data/products.ts
var products = __webpack_require__(7069);
;// CONCATENATED MODULE: ./components/bookpage/FreeTrial.tsx
















var FreeTrial = function(param) {
    var data = param.data, onClose = param.onClose, onSuccess = param.onSuccess;
    var ref = (0,react.useState)({}), freeTrialTags = ref[0], setFreeTrialTags = ref[1];
    var ref1 = (0,react.useState)(false), trial = ref1[0], setTrial = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)([]), hosts = ref3[0], setHosts = ref3[1];
    var ref4 = (0,react.useState)(""), trialselect = ref4[0], setTrialSelect = ref4[1];
    var ref5 = (0,react.useState)(false), forceRender = ref5[0], SetforceRender = ref5[1];
    var ref6 = (0,react.useState)(false), trialExhausted = ref6[0], setTrialExhausted = ref6[1];
    var ref7 = (0,react.useState)({}), api = ref7[0], setApi = ref7[1];
    var ref8 = (0,react.useState)("windows"), activeTab = ref8[0], setActiveTab = ref8[1];
    var router = (0,next_router.useRouter)();
    var slug = router.query.url || "";
    var id = slug ? (0,products/* getProductIdBySlug */.WO)(slug) || null : null;
    var getTabDisplayName = function(tab) {
        switch(tab){
            case "windows":
                return "Windows";
            case "mac":
                return "Mac";
            case "linux":
                return "Linux";
            default:
                return "";
        }
    };
    (0,react.useEffect)(function() {
        setTrialSelect("");
        if (false) {}
        var osType = "windows";
        if (navigator.appVersion.indexOf("Mac") !== -1) osType = "mac";
        else if (navigator.appVersion.indexOf("X11") !== -1 || navigator.appVersion.indexOf("Linux") !== -1) osType = "linux";
        else if (navigator.appVersion.indexOf("X11") !== -1 || navigator.appVersion.indexOf("Win") !== -1) osType = "windows";
        setTrialSelect(osType);
    }, []);
    var getHosts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, token, response, ref2, ref3, ref4, initialTags, ref5, initialTags1, error, ref6, ref7;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios/* default.get */.Z.get("".concat("https://api.vxfx.io", "/host?product=").concat(id), {
                                headers: {
                                    Authorization: "".concat(token),
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if ((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.success) && (response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.data)) {
                            ;
                            setHosts(response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.data);
                            if (trialExhausted && api.supports) {
                                ;
                                initialTags = response === null || response === void 0 ? void 0 : (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.reduce(function(acc, host) {
                                    var ref;
                                    acc[host.name] = (ref = api.supports) === null || ref === void 0 ? void 0 : ref.includes(host.name);
                                    return acc;
                                }, {});
                                setFreeTrialTags(initialTags);
                            } else {
                                ;
                                initialTags1 = response === null || response === void 0 ? void 0 : (ref5 = response.data) === null || ref5 === void 0 ? void 0 : ref5.data.reduce(function(acc, host) {
                                    acc[host.name] = false;
                                    return acc;
                                }, {});
                                setFreeTrialTags(initialTags1);
                            }
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        react_hot_toast_dist/* default.error */.ZP.error((error === null || error === void 0 ? void 0 : (ref6 = error.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.message) || "Failed to load available hosts.");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getHosts() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (id) {
            getHosts();
        }
    // getHosts intentionally excluded: it's recreated every render and should
    // only re-run when `id` changes, not on every trialExhausted/api update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
    var getFreeTrial = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var token, currentSlug, productId, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        token = localStorage.getItem("auth-token");
                        currentSlug = router.query.url || "";
                        productId = currentSlug ? (0,products/* getProductIdBySlug */.WO)(currentSlug) : null;
                        if (!(token && productId)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios/* default.post */.Z.post("".concat("https://api.vxfx.io", "/trial-access-product"), {
                                product: productId
                            }, {
                                headers: {
                                    Authorization: "".concat(token),
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getFreeTrial() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var initializeData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var trialData, ref, previousOs;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getFreeTrial()
                            ];
                        case 1:
                            trialData = _state.sent();
                            if ((trialData === null || trialData === void 0 ? void 0 : trialData.data) && Object.keys(trialData === null || trialData === void 0 ? void 0 : trialData.data).length) {
                                ;
                                setTrialExhausted(true);
                                previousOs = (trialData === null || trialData === void 0 ? void 0 : (ref = trialData.data) === null || ref === void 0 ? void 0 : ref.os) || "linux";
                                setTrialSelect(previousOs);
                                setActiveTab(previousOs);
                                setApi(trialData === null || trialData === void 0 ? void 0 : trialData.data);
                            // Don't set freeTrialTags here, let getHosts handle it
                            }
                            return [
                                2
                            ];
                    }
                });
            // await getHosts();
            });
            return function initializeData() {
                return _ref.apply(this, arguments);
            };
        }();
        initializeData();
    // getFreeTrial intentionally excluded: it's recreated every render and should
    // only re-run when forceRender changes, not on every router.query update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        forceRender
    ]);
    (0,react.useEffect)(function() {
        if (hosts.length > 0 && !trialExhausted) {
            var firstCompatibleHost = hosts.find(function(host) {
                return host.windows;
            });
            if (firstCompatibleHost) {
                setFreeTrialTags(function(prev) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, firstCompatibleHost.name, true));
                });
            }
        }
    }, [
        hosts,
        trialExhausted
    ]);
    (0,react.useEffect)(function() {
        if (trialExhausted && trialselect) {
            setActiveTab(trialselect);
        }
    }, [
        trialExhausted,
        trialselect
    ]);
    (0,react.useEffect)(function() {
        if (!trialExhausted || hosts.length === 0) return;
        var selectedSupports = api.supports || [];
        var updatedTags = hosts.reduce(function(acc, host) {
            acc[host.name] = selectedSupports.includes(host.name);
            return acc;
        }, {});
        // Ensure at least one host stays selected if API returned something empty for some reason
        if (!Object.values(updatedTags).some(Boolean) && hosts[0]) {
            updatedTags[hosts[0].name] = true;
        }
        setFreeTrialTags(updatedTags);
    }, [
        trialExhausted,
        hosts,
        api
    ]);
    var handleIconClick = function(os) {
        if (trialExhausted) return;
        setTrialSelect(os);
        // Find first compatible host for the selected OS
        var firstCompatibleHost = hosts.find(function(host) {
            switch(os){
                case "windows":
                    return host.windows;
                case "mac":
                    return host.mac;
                case "linux":
                    return host.linux;
                default:
                    return false;
            }
        });
        // Create new tags object with all false
        var newTags = {};
        Object.keys(freeTrialTags).forEach(function(key) {
            newTags[key] = false;
        });
        // Set the first compatible host to true if found
        if (firstCompatibleHost) {
            newTags[firstCompatibleHost.name] = true;
        }
        setFreeTrialTags(newTags);
    };
    var isHostCompatible = function(host) {
        if (trialExhausted) {
            var ref;
            return ((ref = api.supports) === null || ref === void 0 ? void 0 : ref.includes(host.name)) && api.os === trialselect;
        }
        switch(trialselect){
            case "windows":
                return host.windows;
            case "mac":
                return host.mac;
            case "linux":
                return host.linux;
            default:
                return false;
        }
    };
    var toggleFreeTrialTag = function(host) {
        if (!isHostCompatible(host) || trialExhausted) {
            return;
        }
        if (freeTrialTags[host.name] && Object.values(freeTrialTags).filter(function(value) {
            return value;
        }).length === 1) {
            // toast.error("One support option must be selected");
            return;
        }
        setFreeTrialTags((0,_define_property/* default */.Z)({}, host.name, !freeTrialTags[host.name]));
    };
    var handleFreeTrial = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var token, ref, currentSlug, productId, selectedFreeTrialSupports, response, alreadyExists, error, ref1, ref2, ref3, ref4;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = localStorage.getItem("auth-token");
                        if (!token) {
                            // setShowlogin(true);
                            localStorage.setItem("redirectTo", router.asPath);
                            router.push("/login");
                            return [
                                2
                            ];
                        }
                        setTrial(true);
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        currentSlug = router.query.url || "";
                        productId = currentSlug ? (0,products/* getProductIdBySlug */.WO)(currentSlug) : null;
                        if (!productId) {
                            react_hot_toast_dist/* default.error */.ZP.error("Product not found.");
                            setLoading(false);
                            return [
                                2
                            ];
                        }
                        selectedFreeTrialSupports = Object.entries(freeTrialTags).filter(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], isSelected = _param[1];
                            return isSelected;
                        }).map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), tagName = _param[0];
                            return tagName;
                        });
                        return [
                            4,
                            axios/* default.post */.Z.post("".concat("https://api.vxfx.io", "/trial-access-request"), {
                                product: productId,
                                supports: selectedFreeTrialSupports,
                                os: trialselect
                            }, {
                                headers: {
                                    Authorization: "".concat(token),
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        alreadyExists = Boolean((ref = response.data) === null || ref === void 0 ? void 0 : ref.alreadyExists);
                        SetforceRender(function(prev) {
                            return !prev;
                        });
                        react_hot_toast_dist/* default.success */.ZP.success(alreadyExists ? "You've already requested a free trial. We'll email you as soon as your download is ready." : "Your free trial request has been submitted. We'll email you as soon as your download is ready.");
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        if ((ref1 = error.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) {
                            ;
                            react_hot_toast_dist/* default.error */.ZP.error((ref3 = error.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.message);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setTrial(false);
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFreeTrial() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (addcart_module_default()).tabs,
                children: [
                    "windows",
                    "mac",
                    "linux"
                ].map(function(tab) {
                    var isActive = activeTab === tab;
                    var tabClasses = [
                        (addcart_module_default()).tabButton,
                        isActive ? (addcart_module_default()).active : "",
                        trialExhausted ? (addcart_module_default()).tabDisabled : "", 
                    ].filter(Boolean).join(" ");
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                        variant: "text-sm",
                        as: "p",
                        color: "secondary",
                        weight: "normal",
                        className: tabClasses,
                        role: "button",
                        "aria-disabled": trialExhausted,
                        tabIndex: trialExhausted ? -1 : 0,
                        onClick: trialExhausted ? undefined : function() {
                            setActiveTab(tab);
                            handleIconClick(tab);
                        },
                        children: getTabDisplayName(tab)
                    }, tab);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (addcart_module_default()).freeTrialHostDiv,
                children: hosts.filter(function(host) {
                    return isHostCompatible(host);
                }).map(function(host) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        className: "".concat((addcart_module_default()).freeTrialHostButton, " ").concat(freeTrialTags[host.name] ? (addcart_module_default()).selectedTag : ""),
                        onClick: function() {
                            toggleFreeTrialTag(host);
                        },
                        variant: "secondary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (addcart_module_default()).hostItemContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (addcart_module_default()).hostNameContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio, {
                                            checked: freeTrialTags[host.name],
                                            onChange: function(checked) {
                                                if (checked) {
                                                    setFreeTrialTags((0,_define_property/* default */.Z)({}, host.name, true));
                                                }
                                            },
                                            size: "sm",
                                            color: "primary"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.ZP, {
                                            variant: "text-sm",
                                            as: "p",
                                            color: "grayDark-300",
                                            style: {
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: "8px"
                                            },
                                            children: [
                                                host.displayName,
                                                host.subItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                                                    variant: "text-sm",
                                                    as: "p",
                                                    color: "grayDark-400",
                                                    children: "including:"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                host.subItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (addcart_module_default()).subItemsRow,
                                    children: hosts.map(function(host) {
                                        var ref;
                                        return host.subItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (addcart_module_default()).hostSubItems,
                                            children: (ref = host.subItems[trialselect]) === null || ref === void 0 ? void 0 : ref.map(function(subItem, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                                                    variant: "text-xs",
                                                    color: "grayDark-300",
                                                    className: (addcart_module_default()).subItem,
                                                    children: subItem
                                                }, index);
                                            })
                                        }, host._id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                    })
                                })
                            ]
                        })
                    }, host._id);
                })
            }),
            trialExhausted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.ZP, {
                as: "p",
                variant: "text-sm",
                color: "grayDark-400",
                style: {
                    marginTop: "12px",
                    textAlign: "center"
                },
                children: [
                    "You have already requested a free trial for ",
                    getTabDisplayName(trialselect),
                    ". Request button is disabled until your current request is processed."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (addcart_module_default()).freeTrialBtnDiv,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        variant: "secondary",
                        onClick: function() {
                            onClose();
                        },
                        fullWidth: true,
                        label: "Cancel",
                        disabled: loading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        variant: "primary",
                        onClick: handleFreeTrial,
                        fullWidth: true,
                        label: loading ? "Requesting Free Trial..." : "Request Free Trial",
                        disabled: trial,
                        loading: loading
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var bookpage_FreeTrial = (FreeTrial);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(10422);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.2.0/node_modules/react-icons/tfi/index.esm.js
var index_esm = __webpack_require__(73321);
// EXTERNAL MODULE: ./utils/licensingService.ts
var licensingService = __webpack_require__(63711);
;// CONCATENATED MODULE: ./components/bookpage/BookPageHome.tsx

















var BookPageHome = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,react.useState)(false), showFreeTrialModal = ref10[0], setShowFreeTrialModal = ref10[1];
    var ref11 = (0,licensingService/* useLicensingSettings */.zH)(), licensingSettings = ref11.data, licensingLoading = ref11.isLoading;
    var ref12 = (0,react.useState)(false), trialAlreadyRequested = ref12[0], setTrialAlreadyRequested = ref12[1];
    var ref13 = (0,react.useState)(true), trialStatusLoading = ref13[0], setTrialStatusLoading = ref13[1];
    var router = (0,next_router.useRouter)();
    var heroComponents = data === null || data === void 0 ? void 0 : (ref = data.components) === null || ref === void 0 ? void 0 : ref.find(function(comp) {
        return comp.name === "hero_section";
    });
    var productoverview = data === null || data === void 0 ? void 0 : (ref1 = data.components) === null || ref1 === void 0 ? void 0 : ref1.find(function(comp) {
        return comp.name === "product_overview";
    });
    var handleScroll = function() {
        modules/* scroller.scrollTo */.OK.scrollTo("more", {
            duration: 50,
            delay: 0,
            smooth: "easeInOutCubic",
            offset: -105
        });
    };
    var handleFreeTrialClick = function() {
        if (trialAlreadyRequested) return;
        if (!(data === null || data === void 0 ? void 0 : data.readyToSell) && !(data === null || data === void 0 ? void 0 : data.hasFreeTrial)) {
            handleScroll();
        } else {
            setShowFreeTrialModal(true);
        }
    };
    var goToMyOrders = function() {
        router.push("/members-area?tab=myorders");
    };
    var handleBuyClick = function() {
        modules/* scroller.scrollTo */.OK.scrollTo("licensing-options", {
            duration: 50,
            delay: 0,
            smooth: "easeInOutCubic",
            offset: -105
        });
    };
    // Check whether the user already has a free trial request for this product,
    // so the outer "Request Free Trial" button can be disabled before the modal opens.
    (0,react.useEffect)(function() {
        var mounted = true;
        var checkTrialStatus = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, token, productId, ref1, response, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            token = localStorage.getItem("auth-token");
                            productId = data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref._id;
                            if (!token || !productId) {
                                setTrialStatusLoading(false);
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                axios/* default.post */.Z.post("".concat("https://api.vxfx.io", "/trial-access-product"), {
                                    product: productId
                                }, {
                                    headers: {
                                        Authorization: token,
                                        "Content-Type": "application/json"
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            if (!mounted) return [
                                2
                            ];
                            setTrialAlreadyRequested(Boolean(((ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.data) && Object.keys(response.data.data).length));
                            return [
                                3,
                                5
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            if (mounted) setTrialStatusLoading(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkTrialStatus() {
                return _ref.apply(this, arguments);
            };
        }();
        checkTrialStatus();
        return function() {
            mounted = false;
        };
    }, [
        data === null || data === void 0 ? void 0 : (ref2 = data.product) === null || ref2 === void 0 ? void 0 : ref2._id
    ]);
    // Check if any license option is enabled
    var hasAnyLicense = licensingSettings ? licensingSettings.showSubscription || licensingSettings.showBinary || licensingSettings.showSourceCode : true; // Default to true if settings not loaded yet
    var modalContent = (0,react.useMemo)(function() {
        if (!showFreeTrialModal) return null;
        return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (bookpagehome_module_default()).popupOverlay,
            onClick: function() {
                return setShowFreeTrialModal(false);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (bookpagehome_module_default()).popupModal,
                onClick: function(e) {
                    return e.stopPropagation();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (bookpagehome_module_default()).form,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (bookpagehome_module_default()).modalPattern,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/modal-background-pattern.svg",
                                alt: "Pattern"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (bookpagehome_module_default()).modalHeader,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (bookpagehome_module_default()).modalHeaderIconContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (bookpagehome_module_default()).modalHeaderIcon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/trial-icon.svg",
                                                alt: "Trial"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (bookpagehome_module_default()).close,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TfiClose */.u5Z, {
                                                onClick: function() {
                                                    return setShowFreeTrialModal(false);
                                                },
                                                style: {
                                                    color: "#61656C",
                                                    cursor: "pointer",
                                                    fontSize: "14px"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (bookpagehome_module_default()).modalHeaderText,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                            variant: "text-md",
                                            color: "grayDark-50",
                                            style: {
                                                zIndex: 1
                                            },
                                            children: "Request Free Trial"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                            variant: "text-sm",
                                            color: "grayDark-400",
                                            style: {
                                                zIndex: 1
                                            },
                                            children: "The trial version allows you to test a single host on a one OS. You can upgrade to the full version to access all hosts and features."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bookpage_FreeTrial, {
                                    data: data,
                                    onClose: function() {
                                        return setShowFreeTrialModal(false);
                                    },
                                    onSuccess: function() {
                                        return setTrialAlreadyRequested(true);
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        }), document.getElementById("modals") || document.body);
    }, [
        showFreeTrialModal,
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (bookpagehome_module_default()).container + " " + (bookpagehome_module_default()).pattern,
                id: "freetrial",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (bookpagehome_module_default()).heroSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (bookpagehome_module_default()).heroContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (bookpagehome_module_default()).appNameContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Fade */.pT, {
                                        triggerOnce: true,
                                        duration: 1000,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/".concat(data === null || data === void 0 ? void 0 : (ref3 = data.product) === null || ref3 === void 0 ? void 0 : ref3.product_name.toLowerCase(), "-app-name-lg.svg"),
                                                alt: data === null || data === void 0 ? void 0 : (ref4 = data.product) === null || ref4 === void 0 ? void 0 : ref4.product_name,
                                                className: (bookpagehome_module_default()).appNameImageLg
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/".concat(data === null || data === void 0 ? void 0 : (ref5 = data.product) === null || ref5 === void 0 ? void 0 : ref5.product_name.toLowerCase(), "-app-name.svg"),
                                                alt: data === null || data === void 0 ? void 0 : (ref6 = data.product) === null || ref6 === void 0 ? void 0 : ref6.product_name,
                                                className: (bookpagehome_module_default()).appNameImage
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                    triggerOnce: true,
                                    duration: 1000,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "display-xl",
                                        as: "h1",
                                        color: "grayDark-50",
                                        weight: "normal",
                                        className: (bookpagehome_module_default()).mainTitle,
                                        children: heroComponents === null || heroComponents === void 0 ? void 0 : heroComponents.mainHeading
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                    triggerOnce: true,
                                    duration: 1000,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-xl",
                                        as: "p",
                                        color: "grayDark-400",
                                        weight: "normal",
                                        className: (bookpagehome_module_default()).description,
                                        children: "Our Video Plugin Development Framework is a game-changing tool designed for developers and video editors alike."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                    triggerOnce: true,
                                    duration: 1000,
                                    style: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (bookpagehome_module_default()).heroButtons,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                onClick: handleScroll,
                                                variant: "secondary",
                                                label: "Get started",
                                                fullWidth: true,
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    width: "16",
                                                    height: "16",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    "aria-hidden": "true",
                                                    focusable: "false",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                            cx: "12",
                                                            cy: "12",
                                                            r: "9",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.5",
                                                            fill: "none"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M10 8L16 12L10 16V8Z",
                                                            fill: "currentColor"
                                                        })
                                                    ]
                                                }),
                                                iconPosition: "left"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                onClick: function() {
                                                    router.push("/contact-us");
                                                },
                                                label: "Chat to us",
                                                fullWidth: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (bookpagehome_module_default()).productOverviewSection,
                        id: "more",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (bookpagehome_module_default()).productOverviewContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (bookpagehome_module_default()).productOverviewLeft,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (bookpagehome_module_default()).productOverviewText,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                                triggerOnce: true,
                                                duration: 1000,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                    variant: "text-md",
                                                    color: "grayDark-300",
                                                    children: "Our studio"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                                triggerOnce: true,
                                                duration: 1000,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                    variant: "display-md",
                                                    color: "grayDark-50",
                                                    weight: "semibold",
                                                    style: {
                                                        marginBottom: "36px"
                                                    },
                                                    children: "Product Overview"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Fade */.pT, {
                                                triggerOnce: true,
                                                duration: 1000,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                        variant: "text-lg",
                                                        color: "grayDark-400",
                                                        children: "Our Video Plugin Development Framework is a game-changing tool designed for developers and video editors alike."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                        variant: "text-lg",
                                                        color: "grayDark-400",
                                                        children: "This framework enables the creation of high-performance video effects and their seamless integration into popular video editing software like DaVinci Resolve and Adobe Premiere Pro."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                                triggerOnce: true,
                                                duration: 1000,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                    variant: "text-lg",
                                                    color: "grayDark-400",
                                                    style: {
                                                        marginBottom: "36px"
                                                    },
                                                    children: "Whether you're a developer looking to expand your capabilities or an editor seeking new creative options, our framework is a versatile solution for all your plugin development needs."
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                                triggerOnce: true,
                                                duration: 1000,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (bookpagehome_module_default()).boxesContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (bookpagehome_module_default()).compatibleWithBox,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "primary",
                                                                    className: (bookpagehome_module_default()).compatibleWithTitle,
                                                                    children: "Support"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (bookpagehome_module_default()).compatibleWithGrid,
                                                                    children: (0,_to_consumable_array/* default */.Z)((data === null || data === void 0 ? void 0 : (ref7 = data.product) === null || ref7 === void 0 ? void 0 : ref7.target_applications) || []).map(function(app, index) {
                                                                        var iconSrc = "";
                                                                        switch(app){
                                                                            case "DaVinci Resolve":
                                                                                iconSrc = "/logo/DaVinci_Resolve_Studio.svg";
                                                                                break;
                                                                            case "Adobe Premiere Pro":
                                                                                iconSrc = "/logo/Adobe_Premiere_Pro.svg";
                                                                                break;
                                                                            case "Sony VEGAS Pro":
                                                                                iconSrc = "/logo/Vegas_Pro.svg";
                                                                                break;
                                                                            case "FinalCut":
                                                                                iconSrc = "/logo/Final_Cut_Pro.svg";
                                                                                break;
                                                                            case "Natron":
                                                                                iconSrc = "/logo/Natron.svg";
                                                                                break;
                                                                            case "Nuke":
                                                                                iconSrc = "/logo/Nuke.svg";
                                                                                break;
                                                                            case "Apple Motion":
                                                                                iconSrc = "/logo/Apple_Motion.svg";
                                                                                break;
                                                                            case "NVIDIA CUDA":
                                                                                iconSrc = "/logo/NVIDIA_CUDA.svg";
                                                                                break;
                                                                            case "Apple Metal":
                                                                                iconSrc = "/logo/Apple_Metal.svg";
                                                                                break;
                                                                            case "OpenCL":
                                                                                iconSrc = "/logo/OpenCL.svg";
                                                                                break;
                                                                            case "CPU":
                                                                                iconSrc = "/logo/cpu.png";
                                                                                break;
                                                                            default:
                                                                                iconSrc = "";
                                                                        }
                                                                        return iconSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (bookpagehome_module_default()).compatibleItem,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: iconSrc,
                                                                                alt: app
                                                                            })
                                                                        }, index) : null;
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (bookpagehome_module_default()).compatibleWithBox,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "primary",
                                                                    className: (bookpagehome_module_default()).compatibleWithTitle,
                                                                    children: "Compatible With"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (bookpagehome_module_default()).compatibleWithGrid,
                                                                    children: (0,_to_consumable_array/* default */.Z)((data === null || data === void 0 ? void 0 : (ref8 = data.product) === null || ref8 === void 0 ? void 0 : ref8.supported_gpu_architectures) || []).map(function(app, index) {
                                                                        var iconSrc = "";
                                                                        switch(app){
                                                                            case "DaVinci Resolve":
                                                                                iconSrc = "/logo/DaVinci_Resolve_Studio.svg";
                                                                                break;
                                                                            case "Adobe Premiere Pro":
                                                                                iconSrc = "/logo/Adobe_Premiere_Pro.svg";
                                                                                break;
                                                                            case "Sony VEGAS Pro":
                                                                                iconSrc = "/logo/Vegas_Pro.svg";
                                                                                break;
                                                                            case "FinalCut":
                                                                                iconSrc = "/logo/Final_Cut_Pro.svg";
                                                                                break;
                                                                            case "Natron":
                                                                                iconSrc = "/logo/Natron.svg";
                                                                                break;
                                                                            case "Nuke":
                                                                                iconSrc = "/logo/Nuke.svg";
                                                                                break;
                                                                            case "Apple Motion":
                                                                                iconSrc = "/logo/Apple_Motion.svg";
                                                                                break;
                                                                            case "NVIDIA CUDA":
                                                                                iconSrc = "/logo/NVIDIA_CUDA.svg";
                                                                                break;
                                                                            case "Apple Metal":
                                                                                iconSrc = "/logo/Apple_Metal.svg";
                                                                                break;
                                                                            case "OpenCL":
                                                                                iconSrc = "/logo/OpenCL.svg";
                                                                                break;
                                                                            case "CPU":
                                                                                iconSrc = "/logo/cpu.png";
                                                                                break;
                                                                            default:
                                                                                iconSrc = "";
                                                                        }
                                                                        var title = "";
                                                                        switch(app){
                                                                            case "NVIDIA CUDA":
                                                                                title = "NVIDIA";
                                                                                break;
                                                                            case "Apple Metal":
                                                                                title = "Apple Metal";
                                                                                break;
                                                                            case "OpenCL":
                                                                                title = "Open CL";
                                                                                break;
                                                                            case "CPU":
                                                                                title = "CPU";
                                                                                break;
                                                                            default:
                                                                                title = "";
                                                                        }
                                                                        return iconSrc ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (bookpagehome_module_default()).availableOnItem,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (bookpagehome_module_default()).compatibleItem,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: iconSrc,
                                                                                        alt: app
                                                                                    })
                                                                                }, index),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                                    variant: "text-xs",
                                                                                    as: "span",
                                                                                    weight: "light",
                                                                                    color: "grayDark-200",
                                                                                    style: {
                                                                                        textAlign: "center"
                                                                                    },
                                                                                    children: title
                                                                                })
                                                                            ]
                                                                        }, "platform-".concat(index)) : null;
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (bookpagehome_module_default()).availableOnBox,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                    variant: "text-sm",
                                                                    color: "primary",
                                                                    className: (bookpagehome_module_default()).availableOnBoxTitle,
                                                                    children: "Available On"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (bookpagehome_module_default()).availableOnGrid,
                                                                    children: ((data === null || data === void 0 ? void 0 : (ref9 = data.product) === null || ref9 === void 0 ? void 0 : ref9.supported_platforms) || []).map(function(platform, index) {
                                                                        var iconSrc = "";
                                                                        switch(platform){
                                                                            case "Windows":
                                                                                iconSrc = "/logo/Windows.svg";
                                                                                break;
                                                                            case "MacOS":
                                                                                iconSrc = "/logo/macOS.svg";
                                                                                break;
                                                                            case "Linux":
                                                                                iconSrc = "/logo/Linux.svg";
                                                                                break;
                                                                            default:
                                                                                iconSrc = "";
                                                                        }
                                                                        var title = "";
                                                                        switch(platform){
                                                                            case "Windows":
                                                                                title = "Windows";
                                                                                break;
                                                                            case "MacOS":
                                                                                title = "MacOS";
                                                                                break;
                                                                            case "Linux":
                                                                                title = "Linux";
                                                                                break;
                                                                            default:
                                                                                title = "";
                                                                        }
                                                                        return iconSrc ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (bookpagehome_module_default()).availableOnItem,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (bookpagehome_module_default()).availableOnIcon,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: iconSrc,
                                                                                        alt: platform
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                                    variant: "text-xs",
                                                                                    as: "span",
                                                                                    weight: "light",
                                                                                    color: "grayDark-200",
                                                                                    style: {
                                                                                        textAlign: "center"
                                                                                    },
                                                                                    children: title
                                                                                })
                                                                            ]
                                                                        }, "platform-".concat(index)) : null;
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                                triggerOnce: true,
                                                duration: 1000,
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (bookpagehome_module_default()).productButtonsWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (bookpagehome_module_default()).productButtons,
                                                            children: !licensingLoading && !hasAnyLicense ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                        href: "/contact-us",
                                                                        label: "Get in touch",
                                                                        fullWidth: true,
                                                                        variant: "secondary"
                                                                    }),
                                                                    trialStatusLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (bookpagehome_module_default()).trialButtonSkeleton,
                                                                        style: {
                                                                            flex: 1
                                                                        }
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                        onClick: handleFreeTrialClick,
                                                                        label: trialAlreadyRequested ? "Free Trial Already Requested" : "Request Free Trial",
                                                                        disabled: trialAlreadyRequested,
                                                                        fullWidth: true
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    trialStatusLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (bookpagehome_module_default()).trialButtonSkeleton,
                                                                        style: {
                                                                            flex: 1
                                                                        }
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                        onClick: handleFreeTrialClick,
                                                                        label: trialAlreadyRequested ? "Free Trial Already Requested" : "Request Free Trial",
                                                                        disabled: trialAlreadyRequested,
                                                                        fullWidth: true,
                                                                        variant: "secondary"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                        onClick: handleBuyClick,
                                                                        label: "Buy Now",
                                                                        fullWidth: true
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        !trialStatusLoading && trialAlreadyRequested && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.ZT, {
                                                            variant: "text-sm",
                                                            color: "grayDark-400",
                                                            className: (bookpagehome_module_default()).trialRequestedHint,
                                                            onClick: goToMyOrders,
                                                            children: [
                                                                "You've already requested a trial for this product. Go to",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (bookpagehome_module_default()).trialRequestedLink,
                                                                    children: "My Orders"
                                                                }),
                                                                " to download it."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (bookpagehome_module_default()).productImageContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                        triggerOnce: true,
                                        duration: 1000,
                                        style: {
                                            height: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/product-image.jpg",
                                            alt: (productoverview === null || productoverview === void 0 ? void 0 : productoverview.mainHeading) || "Product Overview",
                                            layout: "fill",
                                            objectFit: "cover"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            modalContent
        ]
    });
};
/* harmony default export */ var bookpage_BookPageHome = (BookPageHome);


/***/ }),

/***/ 7069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ji": function() { return /* binding */ getProductSlugById; },
/* harmony export */   "WO": function() { return /* binding */ getProductIdBySlug; },
/* harmony export */   "Zc": function() { return /* binding */ productsData; }
/* harmony export */ });
var productsData = [
    {
        id: "6746ae8608b3efcbfedd1063",
        title: "Video Plugins",
        products: [
            {
                id: "6747fa1353ed45d740942f0d",
                product_name: "VxFX",
                icon: "/products/vxfx.png",
                slug: "vxfx"
            }, 
        ]
    }, 
];
/**
 * Finds product ID by slug
 * @param slug - The product slug
 * @returns Product ID or null if not found
 */ function getProductIdBySlug(slug) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = productsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            var product = category.products.find(function(p) {
                return p.slug === slug;
            });
            if (product) {
                return product.id;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
/**
 * Finds product slug by ID
 * @param id - The product ID
 * @returns Product slug or null if not found
 */ function getProductSlugById(id) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = productsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            var product = category.products.find(function(p) {
                return p.id === id;
            });
            if (product) {
                return product.slug;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}


/***/ }),

/***/ 63711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ updateLicensingSettings; },
/* harmony export */   "dO": function() { return /* binding */ fetchLicensingSettings; },
/* harmony export */   "zH": function() { return /* binding */ useLicensingSettings; }
/* harmony export */ });
/* unused harmony exports LICENSING_SETTINGS_QUERY_KEY, useInvalidateLicensingSettings */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15767);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81944);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86607);
/* provided dependency */ var process = __webpack_require__(82985);




var API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || "https://api.vxfx.io" || 0;
function fetchLicensingSettings() {
    return _fetchLicensingSettings.apply(this, arguments);
}
function _fetchLicensingSettings() {
    _fetchLicensingSettings = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var ref, res, ref1, payload;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat(API_BASE_URL, "/licensing"))
                    ];
                case 1:
                    res = _state.sent();
                    payload = (ref1 = (ref = res.data) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : res.data;
                    return [
                        2,
                        {
                            showSubscription: Boolean(payload === null || payload === void 0 ? void 0 : payload.showSubscription),
                            showBinary: Boolean(payload === null || payload === void 0 ? void 0 : payload.showBinary),
                            showSourceCode: Boolean(payload === null || payload === void 0 ? void 0 : payload.showSourceCode)
                        }
                    ];
            }
        });
    });
    return _fetchLicensingSettings.apply(this, arguments);
}
function updateLicensingSettings(payload) {
    return _updateLicensingSettings.apply(this, arguments);
}
function _updateLicensingSettings() {
    _updateLicensingSettings = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(payload) {
        var ref, token, res, ref1, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    token =  true ? localStorage.getItem("auth-token") : 0;
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].patch */ .Z.patch("".concat(API_BASE_URL, "/licensing"), payload, {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: token ? "Bearer ".concat(token) : ""
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    data = (ref1 = (ref = res.data) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : res.data;
                    return [
                        2,
                        {
                            showSubscription: Boolean(data === null || data === void 0 ? void 0 : data.showSubscription),
                            showBinary: Boolean(data === null || data === void 0 ? void 0 : data.showBinary),
                            showSourceCode: Boolean(data === null || data === void 0 ? void 0 : data.showSourceCode)
                        }
                    ];
            }
        });
    });
    return _updateLicensingSettings.apply(this, arguments);
}
var LICENSING_SETTINGS_QUERY_KEY = [
    "licensing-settings"
];
// Shared across every component that reads licensing settings (BookPageHome,
// LicensingOptions, ...) so they hit the API once and share one cached result
// instead of each mounting its own fetch.
function useLicensingSettings() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(LICENSING_SETTINGS_QUERY_KEY, fetchLicensingSettings, {
        staleTime: 60000
    });
}
function useInvalidateLicensingSettings() {
    var queryClient = useQueryClient();
    return function() {
        return queryClient.invalidateQueries(LICENSING_SETTINGS_QUERY_KEY);
    };
}


/***/ }),

/***/ 89482:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radioContainer":"Radio_radioContainer__fndkf","radio":"Radio_radio__8nTM8","input":"Radio_input__d1I8X","radioCircle":"Radio_radioCircle__DCv25","radioDot":"Radio_radioDot__mFJeD","label":"Radio_label__W9nD4","labelDisabled":"Radio_labelDisabled__gKnxg","labelError":"Radio_labelError__C9r_n","errorMessage":"Radio_errorMessage__up_dd","size-sm":"Radio_size-sm__Qv53U","size-md":"Radio_size-md__U4SiP","size-lg":"Radio_size-lg__z_ghX","error":"Radio_error__6VCDp","focused":"Radio_focused__5pOE5","color-primary":"Radio_color-primary__D0vSO","color-secondary":"Radio_color-secondary__7G6CZ","color-success":"Radio_color-success__Wi6Cy","color-warning":"Radio_color-warning__l76_Y","color-error":"Radio_color-error__Z_Jn_","checked":"Radio_checked__XpwyA","disabled":"Radio_disabled__m3SWd"};

/***/ }),

/***/ 3721:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs":"addcart_tabs__jtrDJ","tabButton":"addcart_tabButton__D391U","active":"addcart_active__Zuwvu","tabDisabled":"addcart_tabDisabled__ehv06","freeTrialHostDiv":"addcart_freeTrialHostDiv__vp2HV","freeTrialHostButton":"addcart_freeTrialHostButton__pLNuk","selectedTag":"addcart_selectedTag__6AAy1","allSubItemsContainer":"addcart_allSubItemsContainer__0kRQz","hostSubItemsSection":"addcart_hostSubItemsSection__UMfeQ","hostSubItemsTitle":"addcart_hostSubItemsTitle__uWEIZ","hostItemContainer":"addcart_hostItemContainer__VbDaT","hostNameContainer":"addcart_hostNameContainer__5ZdNj","subItemsRow":"addcart_subItemsRow__6TCcj","hostSubItems":"addcart_hostSubItems__f8xJP","subItem":"addcart_subItem__dWowj","fadeInScale":"addcart_fadeInScale__Ad2zK","freeTrialBtnDiv":"addcart_freeTrialBtnDiv__0R9tZ","bookMainDiv":"addcart_bookMainDiv__JW91A","liness":"addcart_liness__O4Yyu","bookContainer":"addcart_bookContainer__PXy7S","bookSubDiv":"addcart_bookSubDiv__xQnlX","bookBtmMain":"addcart_bookBtmMain__sbLBe","bookRightMain":"addcart_bookRightMain__Dz6fa","bookRightHead":"addcart_bookRightHead__s7mbW","bookLearnBtnDiv":"addcart_bookLearnBtnDiv__UF0Jj","bookLearnMoreBtn":"addcart_bookLearnMoreBtn__z4kIj","pulse-highlight":"addcart_pulse-highlight__aj0ix","loaderWrapper":"addcart_loaderWrapper__ppQ8p","loader":"addcart_loader__naFQ_","spin":"addcart_spin__XccsW","bookPrice":"addcart_bookPrice__W_tli","mainDropDownDiv":"addcart_mainDropDownDiv__mK46f","dropDiv":"addcart_dropDiv___hlYz","dropdownContainer":"addcart_dropdownContainer___vSwf","label":"addcart_label__SvjDi","optionsContainer":"addcart_optionsContainer__6LXiR","title":"addcart_title__b160e","toolTiplabeleDiv":"addcart_toolTiplabeleDiv___bYo4","tooltipcontent":"addcart_tooltipcontent__faAiZ","checkboxGroup":"addcart_checkboxGroup__0bRGy","labeleDiv":"addcart_labeleDiv__AwlTe","price":"addcart_price__t3px1","checkboxWrapper":"addcart_checkboxWrapper__BqX_C","bookRightKeyDiv":"addcart_bookRightKeyDiv__F9Rpj"};

/***/ }),

/***/ 2802:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popupOverlay":"bookpagehome_popupOverlay__FP1s0","popupModal":"bookpagehome_popupModal__sfg5B","modalPattern":"bookpagehome_modalPattern__BGQKj","modalHeader":"bookpagehome_modalHeader__SMy7C","modalHeaderIconContainer":"bookpagehome_modalHeaderIconContainer__ESE_r","modalHeaderIcon":"bookpagehome_modalHeaderIcon__zze9y","form":"bookpagehome_form__3yflc","close":"bookpagehome_close__xB_iT","modalHeaderText":"bookpagehome_modalHeaderText__Le5qS","container":"bookpagehome_container__QIYy4","pattern":"bookpagehome_pattern__I1MwX","heroSection":"bookpagehome_heroSection__F0Q6B","heroContent":"bookpagehome_heroContent__XKQ3A","appNameContainer":"bookpagehome_appNameContainer__xzfwR","appNameImageLg":"bookpagehome_appNameImageLg__1UxSo","appNameImage":"bookpagehome_appNameImage__V3vMk","mainTitle":"bookpagehome_mainTitle__P3GzH","description":"bookpagehome_description__KN_V0","heroButtons":"bookpagehome_heroButtons__g6m2S","productOverviewSection":"bookpagehome_productOverviewSection__93zQy","productOverviewContent":"bookpagehome_productOverviewContent__RYP4R","productOverviewLeft":"bookpagehome_productOverviewLeft__RhJ_O","productOverviewText":"bookpagehome_productOverviewText__4kkIE","boxesContainer":"bookpagehome_boxesContainer__n7mWi","compatibleWithBox":"bookpagehome_compatibleWithBox__Ej7Nc","availableOnBox":"bookpagehome_availableOnBox__4u2wz","compatibleWithTitle":"bookpagehome_compatibleWithTitle__lEaU_","availableOnBoxTitle":"bookpagehome_availableOnBoxTitle__b83jB","compatibleWithGrid":"bookpagehome_compatibleWithGrid__IGsRt","compatibleItem":"bookpagehome_compatibleItem__MkKIp","availableOnGrid":"bookpagehome_availableOnGrid__lt_Ae","availableOnItem":"bookpagehome_availableOnItem__Yol1e","availableOnIcon":"bookpagehome_availableOnIcon__QMUtg","productButtonsWrapper":"bookpagehome_productButtonsWrapper__rR2pQ","productButtons":"bookpagehome_productButtons__JXMvG","trialRequestedHint":"bookpagehome_trialRequestedHint__nERYp","trialButtonSkeleton":"bookpagehome_trialButtonSkeleton__oTUZ5","skeleton-loading":"bookpagehome_skeleton-loading__Yffkr","trialRequestedLink":"bookpagehome_trialRequestedLink__8wbJ8","productImageContainer":"bookpagehome_productImageContainer__1PfDO"};

/***/ }),

/***/ 44454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.2.0/node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.2.0/node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.2.0/node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-icons@4.12.0_react@18.2.0/node_modules/react-icons/lib/esm/index.js




/***/ }),

/***/ 57135:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

}]);